/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

export const Tracking = (): React.JSX.Element | null => {
	let trackingUrl: string | undefined;
	const trackingEnabled = Boolean(
		(!process.env.NEXT_PUBLIC_TRACKING_DISABLED || process.env.NEXT_PUBLIC_TRACKING_DISABLED === "false") &&
		process.env.NEXT_PUBLIC_TRACKING_BASE,
	);
	if (trackingEnabled) {
		trackingUrl = `${process.env.NEXT_PUBLIC_TRACKING_BASE}/tracking.js`;
		// root._epicEnableCookieGuard = true;
		// root.__tracking_base = process.env.NEXT_PUBLIC_TRACKING_BASE;
		if (process.env.NEXT_PUBLIC_DSA_TRACKING_ID) {
			trackingUrl += `?p=${encodeURIComponent(process.env.NEXT_PUBLIC_DSA_TRACKING_ID)}`;
		}
	}
	if (trackingUrl) {
		return <script key="tracking-script" src={trackingUrl} async />;
	}

	return null;
};
